module.exports = __webpack_public_path__ + "img/Mekanika Logo.02bb9e6f.png";